// playline ID を localStorage に保管する単一窓口。
// 直接 window.localStorage を参照する箇所をここに集約し、
// SSR 非対応の前提でブラウザ API へ直接アクセスする。
// プライベートブラウジングや設定で localStorage が無効化されていても
// 呼び出し側がクラッシュしないよう、例外は握り潰して null / no-op に倒す。

const STORAGE_KEY = "palimia.playlineId";
const SCENARIO_STORAGE_KEY = "palimia.playlineScenarioId";

export const playlineStorage = {
  get(): string | null {
    try {
      return window.localStorage.getItem(STORAGE_KEY);
    } catch {
      // localStorage 不可環境では「未保存」と等価に扱う
      return null;
    }
  },

  getScenarioId(): string | null {
    try {
      return window.localStorage.getItem(SCENARIO_STORAGE_KEY);
    } catch {
      return null;
    }
  },

  getForScenario(
    scenarioId: string,
    options?: { requireScenarioMatch?: boolean },
  ): string | null {
    const playlineId = this.get();
    if (playlineId === null) return null;
    if (options?.requireScenarioMatch !== true) return playlineId;

    const storedScenarioId = this.getScenarioId();
    if (storedScenarioId === scenarioId) return playlineId;

    this.clear();
    return null;
  },

  set(playlineId: string, scenarioId?: string): void {
    try {
      window.localStorage.setItem(STORAGE_KEY, playlineId);
      if (scenarioId !== undefined) {
        window.localStorage.setItem(SCENARIO_STORAGE_KEY, scenarioId);
      } else {
        window.localStorage.removeItem(SCENARIO_STORAGE_KEY);
      }
    } catch {
      // 保存失敗はフェイルセーフ：次回起動時に再発行される想定
    }
  },

  clear(): void {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
      window.localStorage.removeItem(SCENARIO_STORAGE_KEY);
    } catch {
      // 削除失敗も握り潰す（次回 set で上書きされるため実害なし）
    }
  },
};
